import React, { useState, useEffect } from 'react'
import Loader from "react-loader-spinner";
import tagManager from "react-gtm-module"
import useDataLayer from '../../../../hooks/useDataLayer';

import mfc from '../../modules/modalFormClient';
import { captureEvent } from 'event-service/modules/capture';

import "../../../contact/ContactForm.scss"
import calc from "../calculator.module.scss"
import view from "../../content/form.module.scss"
import grid from "../../../../scss/flexboxgrid.module.scss"

function ApplyFinancing(props) {
  const { leadURL, siteId, gtmId } = props
  const { finalPrice, vehicleInfo } = props
  const { monthly } = props.extraData
  const pushToDataLayer = useDataLayer()
  const [fields, setFields] = useState({
    firstName: null, lastName: null, email: null, phoneNumber: null, comments: null,
    siteId: siteId, pageSource: props.pageSource, pageURL: props.pageURL
  })

  const [error, setError] = useState([])
  const [statusMsg, setStatusMsg] = useState("")
  const [loading, isLoading] = useState(false)
  const [engagement, setEngagement] = useState(false)

  useEffect(() => {
    if (engagement) {
      captureEvent({
        event: 'asc_form_engagement',
        comm_type: 'form',
        comm_status: 'start',
        element_text: engagement?.innerText,
        department: 'sales',
        form_name: 'Financing Calculator',
        form_type: 'sales',
        item_id:  vehicleInfo.VIN,
        item_number: `${vehicleInfo.Year} ${vehicleInfo.Make} ${vehicleInfo.Model} ${vehicleInfo.Trim}`,
        item_price: `${finalPrice}`,
        item_condition: `${vehicleInfo.IsNew ? 'New' : 'Used'}`,
        item_year: vehicleInfo.Year,
        item_make: vehicleInfo.Make,
        item_model: vehicleInfo.Model,
        item_variant: vehicleInfo.Trim,
        item_color: vehicleInfo.ExteriorColor,
        item_type:'vehicle',
        item_category: vehicleInfo.BodyType,
        item_fuel_type: vehicleInfo.EngineFuelType,
        item_inventory_date: vehicleInfo.InStockDate,
      }, {
        handlers: ['ASC']
      }).then(res => console.log(res)).catch(err => console.log(err))
    }
  }, [engagement])

  const handleTextInput = (name, value) => {
    setStatusMsg("")
    setFields({ ...fields, ...{ [name]: value } })
  }

  const phoneMask = (e) => {
    var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
  }

  const requiredFields = ["VIN", "StockNumber", "Year", "Make", "Model", "Trim"]
  const filterLabels = () => Object.fromEntries(
    requiredFields.map(element => [element, vehicleInfo[element]])
  )

  const submitForm = async (e) => {
    e.preventDefault()

    const missing = mfc.validateForm(fields, ['firstName', 'lastName', 'email', 'phoneNumber'])
    if (missing.length > 0) {
      setError([...missing])
      return setStatusMsg("One or more fields are missing!")
    }

    isLoading(true)

    const body = { ...fields, finalPrice, vehicle: filterLabels() }
    const result = await mfc.sendForm(leadURL, body)
    if (result.hasOwnProperty("error")) {
      setStatusMsg("Uh oh! Something went wrong, please try again!")
    } else {
      captureEvent({
        event: 'asc_retail_process',
        flow_name: 'estimate payment',
        element_title: 'submit',
        flow_outcome: 'crm_update',
        item_payment: `${monthly}`, 
        flow_stage: 'start',
        item_id:  vehicleInfo.VIN,
        item_number: `${vehicleInfo.Year} ${vehicleInfo.Make} ${vehicleInfo.Model} ${vehicleInfo.Trim}`,
        item_price: `${finalPrice}`,
        item_condition: `${vehicleInfo.IsNew ? 'New' : 'Used'}`,
        item_year: vehicleInfo.Year,
        item_make: vehicleInfo.Make,
        item_model: vehicleInfo.Model,
        item_variant: vehicleInfo.Trim,
        item_color: vehicleInfo.ExteriorColor,
        item_type:'vehicle',
        item_category: vehicleInfo.BodyType,
        item_fuel_type: vehicleInfo.EngineFuelType,
        item_inventory_date: vehicleInfo.InStockDate,
      }, {
        handlers: ['ASC']
      }).then(res => console.log(res)).catch(err => console.log(err))
      pushToDataLayer("form-submission", result)
      pushToDataLayer("finance", result)
      setStatusMsg("Success! The message has been sent!")
    }

    isLoading(false)
  }

  return (
    <div className={`contact-formCont ${view["contact-form"]}`}>
      <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "First Name"})}>
        <label htmlFor="firstName">First Name *</label>
        <input className="contact-input" id="firstName" name="firstName" placeholder=""
          style={{ border: error.indexOf("firstName") > -1 && "1px solid red" }}
          onChange={(e) => handleTextInput(e.target.name, e.target.value)} />
      </div>

      <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Last Name"})}>
        <label htmlFor="lastName">Last Name *</label>
        <input className="contact-input" id="lastName" name="lastName" placeholder=""
          style={{ border: error.indexOf("lastName") > -1 && "1px solid red" }}
          onChange={(e) => handleTextInput(e.target.name, e.target.value)} />
      </div>

      <div className={`contact-inputCont contact-phone ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Phone"})}>
        <label htmlFor="phoneNumber">Phone *</label>
        <input className="contact-input" type="tel" pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
          id="phoneNumber" name="phoneNumber" placeholder="(555) 555-5555"
          style={{ border: error.indexOf("phoneNumber") > -1 && "1px solid red" }}
          onChange={(e) => handleTextInput(e.target.name, e.target.value)}
          onInput={phoneMask}
        />
      </div>

      <div className={`contact-inputCont ${grid["col-md-6"]} ${grid["col-sm-12"]}`} onClick={() => setEngagement({innerText: "Email"})}>
        <label htmlFor="email">Email *</label>
        <input className="contact-input" type="email" id="email" name="email" placeholder=""
          style={{ border: error.indexOf("email") > -1 && "1px solid red" }}
          onChange={(e) => handleTextInput(e.target.name, e.target.value)} />
      </div>

      <div className="contact-inputCont contact-border">
        {props.callForPrice && (
          <button className={`contact-button ${calc["button-cta"]}`}
            style={{ float: "left", width: "max-content", padding: "0 1em" }}
            onClick={props.nextPage} >
            CALCULATE PAYMENTS
          </button>
        )
        }

        <button className={`contact-button ${calc["button-cta"]}`}
          onClick={submitForm} >
          {loading === false ? "SUBMIT" :
            <Loader type="ThreeDots" color="white" height={12} width={12} />
          }
        </button>
      </div>

      <div className={`contact-response ${statusMsg.length && "contact-failure"}`}>
        {statusMsg}
      </div>
    </div>
  )
}

ApplyFinancing.defaultProps = {
  leadURL: "",
  disclaimer: ""
}

export default ApplyFinancing